import { render, staticRenderFns } from "./EventFeatureConfig.vue?vue&type=template&id=fee19ace"
import script from "./EventFeatureConfig.js?vue&type=script&lang=js&external"
export * from "./EventFeatureConfig.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports